import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState, useEffect, useCallback } from "react";
import toast from "react-hot-toast";
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import env from "config";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { uploadImageToGhl } from "hook/services";
import ReactCropModal from "../../ReactCropModal/ReactCropModal";
import LogoUpload from "./LogoUpload";
import BrandLogosSection from "./BrandLogosSection";
import SettingsCard from "./SettingsCard";
import TopbarStylingSection from "./TopbarStylingSection";
import CookieConsentBrandingSection from "./CookieConsentBrandingSection";
import SEOSection from "./SEOSection";
import AddNewBusinessHeading from "./AddNewBusinessHeading";
import HomeSectionOrderEditor from "./HomeSectionOrderEditor";
import GhlMediaGallery from "components/GhlMediaGallery";
// Font constants are now imported directly in components that need them

const FIELD_LABELS = {
  topbar_bg: "Topbar background color",
  topbar_text: "Topbar text color",
  topbar_text_hover: "Topbar text hover color",
  topbar_font: "Topbar font",
  topbar_font_size: "Topbar font size",
  home_m_title: "Home meta title",
  home_m_description: "Home meta description",
  add_new_business_heading: "Add new business heading",
  logo: "Header logo",
  footer_logo: "Footer logo",
  auth_logo: "Auth logo",
  Meta_logo: "Favicon",
  default_profile_image: "Default profile image",
  default_cover_image: "Default cover image",
  logo_size: "Header logo size",
  footer_logo_size: "Footer logo size",
  auth_logo_size: "Auth logo size",
};

const labelFor = (name) => FIELD_LABELS[name] || name;

function General({ handleImage, loading, handelThemeData, selectedTheme, buttonLoading }) {
  const inputData = selectedTheme?.theme_data?.general;
  const contentData = selectedTheme?.theme_data?.content;
  const [agency] = useAgencyInfo();
  const [showBusinessesByTagOnHome, setShowBusinessesByTagOnHome] = useState(
    contentData?.showBusinessesByTagOnHome !== false
  );
  const [showBlogsOnHome, setShowBlogsOnHome] = useState(contentData?.showBlogsOnHome !== false);
  const [showFeaturedListingOnHome, setShowFeaturedListingOnHome] = useState(
    contentData?.showFeaturedListingOnHome !== false
  );
  const [showHeroSection, setShowHeroSection] = useState(
    contentData?.showHeroSection !== false
  );
  const [showSiteDescription, setShowSiteDescription] = useState(
    contentData?.showSiteDescription !== false
  );
  const [showFeaturedListingsSlider, setShowFeaturedListingsSlider] = useState(
    contentData?.showFeaturedListingsSlider !== false
  );
  const [showFreeListings, setShowFreeListings] = useState(
    contentData?.showFreeListings !== false
  );
  const [showEvents, setShowEvents] = useState(contentData?.showEvents !== false);
  const [showJobs, setShowJobs] = useState(contentData?.showJobs !== false);
  const [showNews, setShowNews] = useState(contentData?.showNews !== false);
  const [showDeals, setShowDeals] = useState(contentData?.showDeals !== false);
  const [showHomepageOptinOnHome, setShowHomepageOptinOnHome] = useState(
    contentData?.showHomepageOptinOnHome !== false
  );

  useEffect(() => {
    const c = selectedTheme?.theme_data?.content;
    setShowBusinessesByTagOnHome(c?.showBusinessesByTagOnHome !== false);
    setShowBlogsOnHome(c?.showBlogsOnHome !== false);
    setShowFeaturedListingOnHome(c?.showFeaturedListingOnHome !== false);
    setShowHeroSection(c?.showHeroSection !== false);
    setShowSiteDescription(c?.showSiteDescription !== false);
    setShowFeaturedListingsSlider(c?.showFeaturedListingsSlider !== false);
    setShowFreeListings(c?.showFreeListings !== false);
    setShowEvents(c?.showEvents !== false);
    setShowJobs(c?.showJobs !== false);
    setShowNews(c?.showNews !== false);
    setShowDeals(c?.showDeals !== false);
    setShowHomepageOptinOnHome(c?.showHomepageOptinOnHome !== false);
  }, [selectedTheme?.theme_id, selectedTheme?.theme_data?.content]);

  useEffect(() => {
    const g = selectedTheme?.theme_data?.general;
    setLogoSize(g?.logo_size || "medium");
    setFooterLogoSize(g?.footer_logo_size || "medium");
    setAuthLogoSize(g?.auth_logo_size || "medium");
  }, [selectedTheme?.theme_id, selectedTheme?.theme_data?.general]);

  const homeSectionToggleDisabled = buttonLoading || !selectedTheme?.theme_id;
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const SERVER_IP = env.SERVER_IP;
  const [logo, setlogo] = useState(inputData?.logo || "");
  const [Meta_logo, setMeta_logo] = useState(inputData?.Meta_logo || "");
  const [domainupdate, setDomainupdate] = useState(false);
  const [Footer_logo, setFooter_logo] = useState(inputData?.footer_logo || "");
  const [Auth_logo, setAuth_logo] = useState(inputData?.auth_logo || "");
  const [logoSize, setLogoSize] = useState(inputData?.logo_size || "medium");
  const [footerLogoSize, setFooterLogoSize] = useState(inputData?.footer_logo_size || "medium");
  const [authLogoSize, setAuthLogoSize] = useState(inputData?.auth_logo_size || "medium");
  const [previewFooterLogo, setPreviewFooterLogo] = useState(
    Footer_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/b5738fa2-b05a-46db-a2c2-0c0612c76ae2.png"
  );
  const [previewAuthLogo, setPreviewAuthLogo] = useState(
    Auth_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/a742c392-3573-4833-a324-d6e51090ee28.png"
  );
  const [previewLogo, setPreviewLogo] = useState(
    logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/fff1c682-9973-4054-afce-285e5b950f05.png"
  );
  const [previewMetaLogo, setPreviewMetaLogo] = useState(
    Meta_logo ||
      "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/bd948045-7012-4b81-8dfe-8f585c519511.png"
  );
  const [default_profile_image, setDefault_profile_image] = useState(inputData?.default_profile_image || "");
  const [default_cover_image, setDefault_cover_image] = useState(inputData?.default_cover_image || "");
  const [previewDefaultProfile, setPreviewDefaultProfile] = useState(inputData?.default_profile_image || "");
  const [previewDefaultCover, setPreviewDefaultCover] = useState(inputData?.default_cover_image || "");
  const [ghl_connect_logo, setGhl_connect_logo] = useState(inputData?.ghl_connect_logo || "");
  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentImageType, setCurrentImageType] = useState("");
  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);
  const [ghlImageType, setGhlImageType] = useState("");
  const [ghlImageIdType, setGhlImageIdType] = useState("");

  const cropAspectByType = {
    logo: 2,
    footer_logo: 2,
    auth_logo: 2,
    Meta_logo: 1,
    default_profile_image: 1,
    default_cover_image: 2.5,
  };

  const setUploadedUrlForType = (type, url) => {
    if (type === "logo") {
      setlogo(url);
      setPreviewLogo(url);
      handleImage(url, "logo");
    } else if (type === "footer_logo") {
      setFooter_logo(url);
      setPreviewFooterLogo(url);
      handleImage(url, "footer_logo");
    } else if (type === "auth_logo") {
      setAuth_logo(url);
      setPreviewAuthLogo(url);
      handleImage(url, "auth_logo");
    } else if (type === "Meta_logo") {
      setMeta_logo(url);
      setPreviewMetaLogo(url);
      handleImage(url, "Meta_logo");
    } else if (type === "default_profile_image") {
      setDefault_profile_image(url);
      setPreviewDefaultProfile(url);
    } else if (type === "default_cover_image") {
      setDefault_cover_image(url);
      setPreviewDefaultCover(url);
    }
  };

  const openGhlGallery = (type, idType) => {
    setGhlImageType(type);
    setGhlImageIdType(idType);
    setGhlGalleryOpen(true);
  };

  const handleGhlImageSelect = (pick) => {
    if (!pick?.url || !ghlImageType) return;
    setUploadedUrlForType(ghlImageType, pick?.url);
    if (selectedTheme?.theme_id) {
      const label = labelFor(ghlImageType);
      runAutoSave(
        { general: { [ghlImageType]: pick?.url, [ghlImageIdType]: pick?._id } },
        {
          loadingMsg: `Uploading ${label}...`,
          successMsg: `${label} uploaded`,
          errorMsg: `Failed to upload ${label}`,
        }
      ).catch(() => {});
    }
  };

  const url = inputData?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;

  const openCropModal = (file, type) => {
    setCurrentImage(URL.createObjectURL(file));
    setCurrentImageType(type);
    setCropModalOpen(true);
  };

  // Zaključan ratio pri cropu (kao u Content tabu); 1 = 1:1, 2.5 = 5:2
  const currentAspectRatio =
    currentImageType === "default_profile_image"
      ? 1
      : currentImageType === "default_cover_image"
        ? 2.5
        : undefined;

  const AUTO_SAVE_TOAST_ID = "branding-general-autosave";

  const runAutoSave = useCallback(
    (data, { loadingMsg = "Saving...", successMsg = "Saved", errorMsg } = {}) => {
      const promise = handelThemeData(data).then((result) => {
        if (result && result.success === false) {
          throw new Error(result.message || errorMsg || "Failed to save");
        }
        return result;
      });

      toast.promise(
        promise,
        {
          loading: loadingMsg,
          success: successMsg,
          error: (err) => err?.message || errorMsg || "Failed to save",
        },
        { id: AUTO_SAVE_TOAST_ID }
      );

      return promise;
    },
    [handelThemeData]
  );

  const autoSaveField = useCallback(
    (name, value) => {
      if (!name) return;
      if (!selectedTheme?.theme_id) {
        toast.error("Theme is not configured for this agency.");
        return;
      }
      const currentValue = selectedTheme?.theme_data?.general?.[name] ?? "";
      if (currentValue === value) return;
      const label = labelFor(name);
      runAutoSave(
        { general: { [name]: value } },
        {
          loadingMsg: `Updating ${label}...`,
          successMsg: `${label} updated`,
          errorMsg: `Failed to update ${label}`,
        }
      ).catch(() => {});
    },
    [selectedTheme?.theme_id, selectedTheme?.theme_data?.general, runAutoSave]
  );

  const handleLogoSizeChange = useCallback(
    (fieldName, value) => {
      if (!selectedTheme?.theme_id) {
        toast.error("Theme is not configured for this agency.");
        return;
      }
      if (fieldName === "logo_size") setLogoSize(value);
      else if (fieldName === "footer_logo_size") setFooterLogoSize(value);
      else if (fieldName === "auth_logo_size") setAuthLogoSize(value);
      const label = labelFor(fieldName);
      runAutoSave(
        { general: { [fieldName]: value } },
        {
          loadingMsg: `Updating ${label}...`,
          successMsg: `${label} updated`,
          errorMsg: `Failed to update ${label}`,
        }
      ).catch(() => {});
    },
    [selectedTheme?.theme_id, runAutoSave]
  );

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    try {
      const isPng = blob.type === "image/png";
      const file = new File(
        [blob],
        isPng ? "cropped-image.png" : "cropped-image.jpg",
        { type: blob.type }
      );
      const image_response = await uploadImageToGhl(file, agency);

      if (!image_response?.data) {
        console.error("Image upload failed");
        return;
      }

      const uploadedUrl = image_response.data;
      let savedFieldName = null;

      if (currentImageType === "logo") {
        setlogo(uploadedUrl);
        setPreviewLogo(URL.createObjectURL(blob));
        handleImage(uploadedUrl, "logo");
        savedFieldName = "logo";
      } else if (currentImageType === "footer_logo") {
        setFooter_logo(uploadedUrl);
        setPreviewFooterLogo(URL.createObjectURL(blob));
        handleImage(uploadedUrl, "footer_logo");
        savedFieldName = "footer_logo";
      } else if (currentImageType === "auth_logo") {
        setAuth_logo(uploadedUrl);
        setPreviewAuthLogo(URL.createObjectURL(blob));
        handleImage(uploadedUrl, "auth_logo");
        savedFieldName = "auth_logo";
      } else if (currentImageType === "Meta_logo") {
        setMeta_logo(uploadedUrl);
        setPreviewMetaLogo(URL.createObjectURL(blob));
        handleImage(uploadedUrl, "Meta_logo");
        savedFieldName = "Meta_logo";
      } else if (currentImageType === "default_profile_image") {
        setDefault_profile_image(uploadedUrl);
        setPreviewDefaultProfile(URL.createObjectURL(blob));
        savedFieldName = "default_profile_image";
      } else if (currentImageType === "default_cover_image") {
        setDefault_cover_image(uploadedUrl);
        setPreviewDefaultCover(URL.createObjectURL(blob));
        savedFieldName = "default_cover_image";
      }

      if (savedFieldName && selectedTheme?.theme_id) {
        const label = labelFor(savedFieldName);
        runAutoSave(
          { general: { [savedFieldName]: uploadedUrl } },
          {
            loadingMsg: `Uploading ${label}...`,
            successMsg: `${label} uploaded`,
            errorMsg: `Failed to upload ${label}`,
          }
        ).catch(() => {});
      }

      setCropModalOpen(false);
    } catch (error) {
      console.error("Error processing cropped image:", error);
      toast.error("Failed to upload image", { id: AUTO_SAVE_TOAST_ID });
    }
  };

  const handleImageUpload = (e, type) => {
    const file = e.target.files?.[0];
    if (file) {
      openCropModal(file, type);
      // Reset input value so same file can be selected again
      e.target.value = "";
    }
  };

  const handleRemoveImage = (fieldName, clearStates) => {
    clearStates();
    if (selectedTheme?.theme_id) {
      const label = labelFor(fieldName);
      runAutoSave(
        { general: { [fieldName]: "" } },
        {
          loadingMsg: `Removing ${label}...`,
          successMsg: `${label} removed`,
          errorMsg: `Failed to remove ${label}`,
        }
      ).catch(() => {});
    }
  };

  const handleShowBusinessesByTagOnHomeChange = () => {
    if (!selectedTheme?.theme_id) {
      toast.error("Theme is not configured for this agency.");
      return;
    }
    const newValue = !showBusinessesByTagOnHome;
    setShowBusinessesByTagOnHome(newValue);
    handelThemeData({ content: { showBusinessesByTagOnHome: newValue } });
    toast.success(
      newValue
        ? "The home page will show businesses grouped by listing label (tag)."
        : "The home page will hide businesses grouped by listing label (tag)."
    );
  };

  const handleShowBlogsOnHomeChange = () => {
    if (!selectedTheme?.theme_id) {
      toast.error("Theme is not configured for this agency.");
      return;
    }
    const newValue = !showBlogsOnHome;
    setShowBlogsOnHome(newValue);
    handelThemeData({ content: { showBlogsOnHome: newValue } });
    toast.success(
      newValue
        ? "The home page will show the blog section."
        : "The home page will hide the blog section."
    );
  };

  const handleShowFeaturedListingOnHomeChange = () => {
    if (!selectedTheme?.theme_id) {
      toast.error("Theme is not configured for this agency.");
      return;
    }
    const newValue = !showFeaturedListingOnHome;
    setShowFeaturedListingOnHome(newValue);
    handelThemeData({ content: { showFeaturedListingOnHome: newValue } });
    toast.success(
      newValue
        ? "The home page will show the premium listings showcase (carousel)."
        : "The home page will hide the premium listings showcase (carousel)."
    );
  };

  const makeHomeSectionToggleHandler = (
    currentValue,
    setter,
    fieldName,
    { onLabel, offLabel }
  ) => () => {
    if (!selectedTheme?.theme_id) {
      toast.error("Theme is not configured for this agency.");
      return;
    }
    const newValue = !currentValue;
    setter(newValue);
    handelThemeData({ content: { [fieldName]: newValue } });
    toast.success(newValue ? onLabel : offLabel);
  };

  const handleShowHeroSectionChange = makeHomeSectionToggleHandler(
    showHeroSection,
    setShowHeroSection,
    "showHeroSection",
    {
      onLabel: "The home page will show the hero section.",
      offLabel: "The home page will hide the hero section.",
    }
  );

  const handleShowSiteDescriptionChange = makeHomeSectionToggleHandler(
    showSiteDescription,
    setShowSiteDescription,
    "showSiteDescription",
    {
      onLabel: "The home page will show the site description section.",
      offLabel: "The home page will hide the site description section.",
    }
  );

  const handleShowFeaturedListingsSliderChange = makeHomeSectionToggleHandler(
    showFeaturedListingsSlider,
    setShowFeaturedListingsSlider,
    "showFeaturedListingsSlider",
    {
      onLabel: "The home page will show the featured listings slider.",
      offLabel: "The home page will hide the featured listings slider.",
    }
  );

  const handleShowFreeListingsChange = makeHomeSectionToggleHandler(
    showFreeListings,
    setShowFreeListings,
    "showFreeListings",
    {
      onLabel: "The home page will show free listings.",
      offLabel: "The home page will hide free listings.",
    }
  );

  const handleShowEventsChange = makeHomeSectionToggleHandler(
    showEvents,
    setShowEvents,
    "showEvents",
    {
      onLabel: "The home page will show the events section.",
      offLabel: "The home page will hide the events section.",
    }
  );

  const handleShowJobsChange = makeHomeSectionToggleHandler(
    showJobs,
    setShowJobs,
    "showJobs",
    {
      onLabel: "The home page will show the jobs section.",
      offLabel: "The home page will hide the jobs section.",
    }
  );

  const handleShowNewsChange = makeHomeSectionToggleHandler(
    showNews,
    setShowNews,
    "showNews",
    {
      onLabel: "The home page will show the news section.",
      offLabel: "The home page will hide the news section.",
    }
  );

  const handleShowDealsChange = makeHomeSectionToggleHandler(
    showDeals,
    setShowDeals,
    "showDeals",
    {
      onLabel: "The home page will show the deals section.",
      offLabel: "The home page will hide the deals section.",
    }
  );

  const handleShowHomepageOptinOnHomeChange = makeHomeSectionToggleHandler(
    showHomepageOptinOnHome,
    setShowHomepageOptinOnHome,
    "showHomepageOptinOnHome",
    {
      onLabel: "The home page will show the homepage optin section.",
      offLabel: "The home page will hide the homepage optin section.",
    }
  );

  return (
    <div className="sd-settings-branding-tab">
      <SoftBox>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          {/* Left Half - Brand Logos */}
          <BrandLogosSection
            logo={logo}
            previewLogo={previewLogo}
            Auth_logo={Auth_logo}
            previewAuthLogo={previewAuthLogo}
            Footer_logo={Footer_logo}
            previewFooterLogo={previewFooterLogo}
            Meta_logo={Meta_logo}
            previewMetaLogo={previewMetaLogo}
            handleImageUpload={handleImageUpload}
            onGhlPick={openGhlGallery}
            inputData={inputData}
            logoSize={logoSize}
            footerLogoSize={footerLogoSize}
            authLogoSize={authLogoSize}
            onLogoSizeChange={handleLogoSizeChange}
            onRemoveLogo={() =>
              handleRemoveImage("logo", () => {
                setlogo("");
                setPreviewLogo("");
                handleImage("", "logo");
              })
            }
            onRemoveAuthLogo={() =>
              handleRemoveImage("auth_logo", () => {
                setAuth_logo("");
                setPreviewAuthLogo("");
                handleImage("", "auth_logo");
              })
            }
            onRemoveFooterLogo={() =>
              handleRemoveImage("footer_logo", () => {
                setFooter_logo("");
                setPreviewFooterLogo("");
                handleImage("", "footer_logo");
              })
            }
            onRemoveMetaLogo={() =>
              handleRemoveImage("Meta_logo", () => {
                setMeta_logo("");
                setPreviewMetaLogo("");
                handleImage("", "Meta_logo");
              })
            }
          />

          {/* Right Half - Topbar Styling */}
          <TopbarStylingSection
            inputData={inputData}
            autoSaveField={autoSaveField}
          />

          <SettingsCard
            title="Home page sections"
            subtitle="Choose which blocks appear on your directory landing page and drag to set their order. Other pages, listing labels, blogs outside this page, and filters stay as they are."
            gridProps={{ xs: 12 }}
          >
            <HomeSectionOrderEditor
              contentData={contentData}
              handelThemeData={handelThemeData}
              buttonLoading={buttonLoading}
              selectedTheme={selectedTheme}
              sections={[
                {
                  id: "hero",
                  title: "Hero section on the home page",
                  description:
                    "The banner area at the top of the home page with the main image, headline, sub-heading, and search bar. Other pages are not affected.",
                  checked: showHeroSection,
                  onToggle: handleShowHeroSectionChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "siteDescription",
                  title: "Site description on the home page",
                  description:
                    "The introductory text block under the hero with your heading, description copy, logo image, and Learn More / Contact Us buttons.",
                  checked: showSiteDescription,
                  onToggle: handleShowSiteDescriptionChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "featuredListings",
                  title: "Premium listings showcase on the home page",
                  description:
                    "The large carousel of premium plan businesses between Businesses by Tags and the blog block. Other featured grids above are not affected.",
                  checked: showFeaturedListingOnHome,
                  onToggle: handleShowFeaturedListingOnHomeChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "freeListings",
                  title: "Free listings on the home page",
                  description:
                    "The grid of free-plan businesses on the home page. Free listings on other pages are not affected.",
                  checked: showFreeListings,
                  onToggle: handleShowFreeListingsChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "businessesByTag",
                  title: "Businesses by tag on the home page",
                  description:
                    "Turn this off to hide the section that groups listings by listing label. Tags and filters elsewhere are not affected.",
                  checked: showBusinessesByTagOnHome,
                  onToggle: handleShowBusinessesByTagOnHomeChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "featuredSlider",
                  title: "Featured listings slider on the home page",
                  description:
                    "The featured listings slider that appears below Businesses by Tags. Separate from the premium listings showcase above.",
                  checked: showFeaturedListingsSlider,
                  onToggle: handleShowFeaturedListingsSliderChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "blogs",
                  title: "Blog section on the home page",
                  description:
                    "Turn this off to remove the blog block from the directory home page only. Blog content on listings and other pages is not affected.",
                  checked: showBlogsOnHome,
                  onToggle: handleShowBlogsOnHomeChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "events",
                  title: "Events section on the home page",
                  description:
                    "Turn this off to remove the events block from the home page only. The Events page itself is not affected.",
                  checked: showEvents,
                  onToggle: handleShowEventsChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "news",
                  title: "News section on the home page",
                  description:
                    "Turn this off to remove the news feeds block from the home page only. The News page itself is not affected.",
                  checked: showNews,
                  onToggle: handleShowNewsChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "jobs",
                  title: "Jobs section on the home page",
                  description:
                    "Turn this off to remove the jobs block from the home page only. The Jobs page itself is not affected.",
                  checked: showJobs,
                  onToggle: handleShowJobsChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "deals",
                  title: "Deals section on the home page",
                  description:
                    "Turn this off to remove the deals block from the home page only. The Deals page itself is not affected.",
                  checked: showDeals,
                  onToggle: handleShowDealsChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
                {
                  id: "homepageOptin",
                  title: "Homepage Optin section on the home page",
                  description:
                    "The optin banner with a headline, sub-headline, background image, and connected GoHighLevel form. Configure its content in the Content tab.",
                  checked: showHomepageOptinOnHome,
                  onToggle: handleShowHomepageOptinOnHomeChange,
                  toggleDisabled: homeSectionToggleDisabled,
                },
              ]}
            />
          </SettingsCard>

          <CookieConsentBrandingSection />

          {/* Left - Listing placeholders (same style as Brand Logos, no upload button) */}
          <SettingsCard
            title="Listing placeholders"
            subtitle="Default images shown when a business has no profile or cover image set. Click the box to upload."
            gridProps={{
              xs: 12,
              sx: {
                "@media (min-width: 1100px)": {
                  flexBasis: "calc(50% - 12px)",
                  maxWidth: "calc(50% - 12px)",
                  width: "calc(50% - 12px)",
                  marginRight: "24px"
                }
              }
            }}
          >
            <SoftBox
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                flexWrap: "wrap",
                gap: { xs: 2, sm: 1.5 },
                rowGap: { xs: 2, sm: 2.5 },
                width: "100%"
              }}
            >
              <LogoUpload
                title="Default profile image"
                value={default_profile_image}
                previewValue={previewDefaultProfile}
                defaultValue=""
                name="default_profile_image"
                onChange={(e) => handleImageUpload(e, "default_profile_image")}
                recommendation="Recommended: (500px x 500px) 1:1 ratio. 1MB size."
                size="small"
                hideUploadButton
                onRemove={() =>
                  handleRemoveImage("default_profile_image", () => {
                    setDefault_profile_image("");
                    setPreviewDefaultProfile("");
                  })
                }
                onGhlPick={() => openGhlGallery("default_profile_image", "default_profile_image_id")}
              />
              <LogoUpload
                title="Default cover image"
                value={default_cover_image}
                previewValue={previewDefaultCover}
                defaultValue=""
                name="default_cover_image"
                onChange={(e) => handleImageUpload(e, "default_cover_image")}
                recommendation="Recommended: (1750px x 700px) 5:2 ratio. 1MB size."
                size="large"
                hideUploadButton
                onRemove={() =>
                  handleRemoveImage("default_cover_image", () => {
                    setDefault_cover_image("");
                    setPreviewDefaultCover("");
                  })
                }
                onGhlPick={() => openGhlGallery("default_cover_image", "default_cover_image_id")}
              />
            </SoftBox>
          </SettingsCard>

          {/* Right - SEO */}
          <SEOSection
            inputData={inputData}
            autoSaveField={autoSaveField}
            gridProps={{
              xs: 12,
              sx: {
                "@media (min-width: 1100px)": {
                  flexBasis: "calc(50% - 12px)",
                  maxWidth: "calc(50% - 12px)",
                  width: "calc(50% - 12px)"
                }
              }
            }}
          />
          <AddNewBusinessHeading
            inputData={inputData}
            autoSaveField={autoSaveField}
            gridProps={{
              xs: 12,
              sx: {
                "@media (min-width: 1100px)": {
                  flexBasis: "calc(50% - 12px)",
                  maxWidth: "calc(50% - 12px)",
                  width: "calc(50% - 12px)"
                }
              }
            }}
          />

          {openWhitelabelModal && (
            <div className="modal-zz-confirm" onClick={() => setopenWhitelabelModal(false)}>
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ border: "1px solid black ", position: "relative" }}
              >
                <h2 className="text-center font-14"> Connect white label domain</h2>
                <span className="crossison">X</span>
                <div className="list-model0">
                  <p>
                    Connect your own domain to the system (without https://)
                    maybetech.yourdomain.com
                  </p>
                  <p>
                    {" "}
                    You can use any domain you own or you can create a sub-domain like
                    maybetech.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className="listtext">
                      <b>1.</b> Refer to your domain registrar&apos;s control panel, choose desired
                      domain zone.
                    </li>

                    <li className="listtext">
                      {" "}
                      <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type, enter your domain/subdomain name and point it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u>{" "}
                    </li>
                    <li className="listtext">
                      {" "}
                      <b>3.</b> We will do the rest!{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Grid>
      </SoftBox>

      {/* Image Crop Modal */}
      {/* <Dialog open={cropModalOpen} onClose={() => setCropModalOpen(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <SoftTypography variant="h5" gutterBottom>
            Crop Image
          </SoftTypography>
          <Box display="flex" flexDirection="column" alignItems="center">
        
            <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        // aspectRatio={currentAspectRatio}
      />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCropModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleCroppedImage}
            variant="contained"
            color="primary"
            // disabled={!completedCrop}
          >
            Apply Crop
          </Button>
        </DialogActions>
      </Dialog> */}
      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        aspectRatio={currentAspectRatio}
        preferPng={["logo", "footer_logo", "auth_logo", "Meta_logo", "default_profile_image", "default_cover_image"].includes(currentImageType)}
      />

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImageSelect}
        title={`Select ${labelFor(ghlImageType) || "Image"}`}
        enableCrop
        cropAspectRatio={cropAspectByType[ghlImageType] ?? null}
      />
    </div>
  );
}

export default General;
